import {Button, Layout, Tabs} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import SUGMDT1 from './SUGMDT1';
import SUGMDT2 from './SUGMDT2';
import SUGMDT3 from './SUGMDT3';
import SUGMDT4 from './SUGMDT4';
import SUGMDT5 from './SUGMDT5';
import SUGMDT6 from './SUGMDT6';

const Content = Layout;

const SUGMDTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);
  const [Tno, setTno] = useState(appColors['ColorX']);
  const [Gno, setGno] = useState(appColors['ColorG2']);
  const [To, setTo] = useState(appColors['ColorX']);
  const [Go, setGo] = useState(appColors['ColorG2']);
  const [oT, setoT] = useState(appColors['ColorX']);
  const [oG, setoG] = useState(appColors['ColorG2']);
  const [OnT, setOnT] = useState(appColors['ColorX']);
  const [OnG, setOnG] = useState(appColors['ColorG2']);
  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTUno('white');
      setGUno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'tres') {
      setTno('white');
      setGno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'cuatro') {
      setTo('white');
      setGo(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'cinco') {
      setoT('white');
      setoG(appColors['ColorX']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'seis') {
      setOnT('white');
      setOnG(appColors['ColorX']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
    }
  };
  const items_ = [
    {label: <Button style={{width: '14vh', height: '13vh', top: '2.3vh', fontSize: '1.5vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>Chimera<br/>(for cleaning<br/>a PDB file)</Button>, key: 'uno', children: <SUGMDT1/>},
    {label: <Button style={{width: '15vh', height: '13vh', top: '2.3vh', fontSize: '1.5vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Molegro (for<br/>cleaning<br/>a PDB file)</Button>, key: 'dos', children: <SUGMDT2/>},
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '1.8vh', borderWidth: '1.5vh', borderRadius: '1vh', color: Tno, fontWeight: 'bold', borderColor: Gno, background: Gno}}>HDock</Button>, key: 'tres', children: <SUGMDT3/>},
    {label: <Button style={{width: '15vh', height: '13vh', top: '2.3vh', fontSize: '1.8vh', borderWidth: '1.5vh', borderRadius: '1vh', color: To, fontWeight: 'bold', borderColor: Go, background: Go}}>PatchDock</Button>, key: 'cuatro', children: <SUGMDT4/>},
    {label: <Button style={{width: '15vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: oT, fontWeight: 'bold', borderColor: oG, background: oG}}>HADDOCK</Button>, key: 'cinco', children: <SUGMDT5/>},
    {label: <Button style={{width: '9.5vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: OnT, fontWeight: 'bold', borderColor: OnG, background: OnG}}>PLIP</Button>, key: 'seis', children: <SUGMDT6/>},
  ];
  return (
    <Layout style={{margin: '-5.2vh 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{padding: '2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='1vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default SUGMDTabs;
